var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2262 6.11682C15.4072 6.28269 15.4194 6.56383 15.2535 6.74477L8.73503 13.8559C8.65312 13.9452 8.53826 13.9973 8.41706 13.9999C8.29587 14.0025 8.17885 13.9555 8.09314 13.8698L5.13017 10.9069C4.95661 10.7333 4.95661 10.4519 5.13017 10.2783C5.30374 10.1048 5.58515 10.1048 5.75871 10.2783L8.39345 12.9131L14.5983 6.14412C14.7642 5.96318 15.0453 5.95096 15.2262 6.11682Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.d769ac3ad91bfff15abbb55a9dd2e2d9.svg";
export { ForwardRef as ReactComponent };